<!-- 申请Demo/样品 表单 -->
<template>
    <div class="apply-form-container">
        <van-popup v-model="applyForm" :safe-area-inset-bottom="true">
            <div class="form-container">
                <div class="form-content">
                    <div class="btn-switch">
                        <div>活动报名</div>
                    </div>
                    <transition name="van-fade">
                        <div v-show="showForm">
                            <div class="form-list">
                                <div class="item">
                                    <label class="hint-title"><span class="sign">*</span>姓名：</label>
                                    <div class="content">
                                        <div class="left-icon">
                                            <i class="iconfont icon-xingming"></i>
                                        </div>
                                        <div class="right-input">
                                            <input type="text" placeholder="请输入姓名" v-model="formItem.name" @blur="blurChange">
                                        </div>
                                    </div>
                                </div>
                                <div class="item">
                                    <label class="hint-title"><span class="sign">*</span>手机：</label>
                                    <div class="content">
                                        <div class="left-icon">
                                            <i class="iconfont icon-dianhua"></i>
                                        </div>
                                        <div class="right-input">
                                            <input type="number" placeholder="请输入手机号" v-model="formItem.mobile" @blur="blurChange">
                                        </div>
                                    </div>
                                </div>
                                 <div class="item">
                                    <label class="hint-title"><span class="sign">*</span>验证码：</label>
                                    <div class="content">
                                        <div class="left-icon">
                                            <i class="iconfont icon-yanzhengyanzhengma"></i>
                                        </div>
                                        <div class="right-input code_input">
                                            <input style="flex:1" type="number" placeholder="请输入验证码" v-model="formItem.code" @blur="blurChange">
                                            <button  @click="getCode" :disabled='getCodeState' style="color:#000;font-size:12px;">{{ getCodeText }}</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="item">
                                    <label class="hint-title"><span class="sign">*</span>邮箱：</label>
                                    <div class="content">
                                        <div class="left-icon">
                                            <i class="iconfont icon-youxiang"></i>
                                        </div>
                                        <div class="right-input">
                                            <input type="email" placeholder="请输入邮箱" v-model="formItem.email" @blur="blurChange">
                                        </div>
                                    </div>
                                </div>
                                <div class="item">
                                    <label class="hint-title"><span class="sign">*</span>城市：</label>
                                    <div class="content">
                                        <div class="left-icon">
                                            <i class="iconfont icon-gongsi"></i>
                                        </div>
                                        <div class="right-input">
                                            <input readonly="readonly" type="text" placeholder="请选择城市" v-model="formItem.city" @click="blurCity">
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="item">
                                    <label class="hint-title"><span class="sign">*</span>行业：</label>
                                    <div class="content">
                                        <div class="left-icon">
                                            <i class="iconfont icon-gongsi"></i>
                                        </div>
                                        <div class="right-input">
                                            <input readonly="readonly" type="text" placeholder="请选择行业" v-model="industryName" @click="blurIndustry">
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="item">
                                    <label class="hint-title"><span class="sign">*</span>公司：</label>
                                    <div class="content">
                                        <div class="left-icon">
                                            <i class="iconfont icon-gongsi"></i>
                                        </div>
                                        <div class="right-input">
                                            <input type="text" placeholder="请输入公司名" v-model="formItem.company" @blur="blurChange">
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="item">
                                    <label class="hint-title"><span class="sign">*</span>您是：（单选）</label>
                                    <div class="radio-container">
                                        <van-radio-group v-model="formItem.identity" direction="horizontal" :checked-color="checkedColor" icon-size="16px">
                                            <van-radio name="终端用户">终端用户</van-radio>
                                            <van-radio name="经销商">经销商</van-radio>
                                        </van-radio-group>
                                    </div>
                                </div>
                                <div class="item">
                                    <label class="hint-title"><span class="sign">*</span>您感兴趣的产品：（多选）</label>
                                    <van-checkbox-group v-model="formItem.like_product">
                                        <div class="checkbox-container">
                                            <div class="checkbox-option">
                                                <van-checkbox name="移液器" :checked-color="checkedColor" shape="square" icon-size="16px">移液器</van-checkbox>
                                            </div>
                                            <div class="checkbox-option">
                                                <van-checkbox name="分液器" :checked-color="checkedColor" shape="square" icon-size="16px">分液器</van-checkbox>
                                            </div>
                                            <!-- <div class="checkbox-option">
                                                <van-checkbox name="离心机" :checked-color="checkedColor" shape="square" icon-size="16px">离心机</van-checkbox>
                                            </div> -->
                                             <div class="checkbox-option">
                                                <van-checkbox name="台式离心机" :checked-color="checkedColor" shape="square" icon-size="16px">台式离心机</van-checkbox>
                                            </div>
                                             <div class="checkbox-option">
                                                <van-checkbox name="落地式离心机" :checked-color="checkedColor" shape="square" icon-size="16px">落地式离心机</van-checkbox>
                                            </div>
                                             <div class="checkbox-option">
                                                <van-checkbox name="超速离心机" :checked-color="checkedColor" shape="square" icon-size="16px">超速离心机</van-checkbox>
                                            </div>
                                            <div class="checkbox-option">
                                                <van-checkbox name="CO2 培养箱" :checked-color="checkedColor" shape="square" icon-size="16px">CO2 培养箱</van-checkbox>
                                            </div>
                                            <div class="checkbox-option">
                                                <van-checkbox name="PCR 仪" :checked-color="checkedColor" shape="square" icon-size="16px">PCR 仪</van-checkbox>
                                            </div>
                                            <div class="checkbox-option">
                                                <van-checkbox name="超低温冰箱" :checked-color="checkedColor" shape="square" icon-size="16px">超低温冰箱</van-checkbox>
                                            </div>
                                            <div class="checkbox-option">
                                                <van-checkbox name="生物反应器" :checked-color="checkedColor" shape="square" icon-size="16px">生物反应器</van-checkbox>
                                            </div>
                                            <div class="checkbox-option">
                                                <van-checkbox name="生物摇床" :checked-color="checkedColor" shape="square" icon-size="16px">生物摇床</van-checkbox>
                                            </div>
                                            <div class="checkbox-option">
                                                <van-checkbox name="自动移液工作站相关" :checked-color="checkedColor" shape="square" icon-size="16px">自动移液工作站相关</van-checkbox>
                                            </div>
                                            <div class="checkbox-option">
                                                <van-checkbox name="混匀仪和孵育器" :checked-color="checkedColor" shape="square" icon-size="16px">混匀仪和孵育器</van-checkbox>
                                            </div>
                                            <div class="checkbox-option">
                                                <van-checkbox name="显微操作相关" :checked-color="checkedColor" shape="square" icon-size="16px">显微操作相关</van-checkbox>
                                            </div>
                                            <div class="checkbox-option">
                                                <van-checkbox name="耗材" :checked-color="checkedColor" shape="square" icon-size="16px">耗材</van-checkbox>
                                            </div>
                                        </div>
                                    </van-checkbox-group>
                                </div>
                                <div class="item">
                                    <label class="hint-title"><span class="sign">*</span>您的购买计划：（单选）</label>
                                    <div class="radio-container">
                                        <van-radio-group v-model="formItem.buy_plan" direction="horizontal" :checked-color="checkedColor" icon-size="16px">
                                            <van-radio name="半年内">半年内</van-radio>
                                            <van-radio name="一年内">一年内</van-radio>
                                            <van-radio name="暂无需求">暂无需求</van-radio>
                                        </van-radio-group>
                                    </div>
                                </div>
                                <div class="item privacy-foo" v-if="privacyform.status == 1">
                                    <!-- <van-radio-group v-model="formItem.buy_plan" direction="horizontal" :checked-color="checkedColor" icon-size="16px">
                                        <van-radio name="半年内">隐私条款</van-radio>
                                    </van-radio-group> -->
                                    <van-checkbox-group v-model="formItem.privacyData">
                                        <van-checkbox name="隐私" :checked-color="checkedColor" shape="square" icon-size="16px" style="margin-right:3px"></van-checkbox>
                                    </van-checkbox-group>
                                    <span class="f-t-s" style="vertical-align: middle;">{{ privacyform.desc }}</span><span @click="gotoprivacy" style="color: #6cc4da;vertical-align: middle;">《{{ privacyform.title }}》</span>
                                </div>
                            </div>
                            <button class="commit-btn" @click="commitApplyForm">提交</button>
                        </div>
                    </transition>
                </div>
            </div>
        </van-popup>
        <!-- 行业 -->
        <van-popup v-model="industryShow" class="pop-indus"  round position="bottom">
            <!-- <van-picker style="width: rem(303);" @confirm="onConfirm" @cancel="onCancel" show-toolbar title="请选择" :columns="labelList" value-key="name" /> -->
            <van-cascader v-model="fieldValue" active-color="#6cc4da" :options="labelList" :field-names="fieldNames"  @finish="onConfirm" @close="onCancel"></van-cascader>
        </van-popup>
        <!-- 城市 -->
        <van-popup v-model="cityShow" round position="bottom">
            <van-area @confirm="handleCitySure" @cancel="cityShow = false" title="城市选择" :area-list="areaList" :columns-num="2" />
        </van-popup>
        <van-popup v-model="commitSuccess" :close-on-click-overlay="closeOverlay" :safe-area-inset-bottom="true">
            <div class="success-container">
                <img src="@/assets/img/success.png" class="success-img" alt="">
                <h3 class="h3-tit">{{successHint}}</h3>
                <div class="hint-text" v-show="successHint != '签到成功'">
                    <p>请扫码关注我们的公众号，以便接收后续信息，谢谢</p>
                </div>
                <img src="@/assets/img/official.jpg" alt="" class="official-img">
                <div class="close-icon" @click="closeEvent">
                    <i class="iconfont icon-quxiao"></i>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { activityCreateForm,getPricacy,getOldActivity,getPhoneCode } from '@/api/activity'
import { getIndustryLabel, updateTag, getUserInfoData } from '@/api/label'
import { throttle } from '@/libs/util'
import { areaList } from '@vant/area-data'
export default {
    data () {
        return {
            fieldValue: '',
            fieldNames: {
                text: 'name',
                value: 'id',
            },
            industry_parent_id: '',
            industry_id: '',
            industryName: '', // 行业的名称
            industryShow:false,
            areaList, // 城市
            cityName: '', // 城市名称
            cityShow: false,
            labelList: [], // 行业的列表
            activity_id: '',
            applyForm: false, // 表单是否显示
            // transitionEffect: 'van-fade', // 过渡效果
            showForm: true,
            commitSuccess: false, // 表单提交成功显示的弹窗
            closeOverlay: false, // 是否在点击遮罩层后关闭
            checkedColor: '#6cc4da', // 单选多选选中的颜色
            formItem: {
                name: '', // 名字
                mobile: '', // 手机号
                email: '', // 邮箱
                company: '', // 公司名
                city: '', // 城市
                // company_address: '', // 公司地址
                // poisition: '',
                is_sign: '0',
                identity: '', // 身份
                like_product: [], // 感兴趣的产品
                privacyData: [], // 隐私选中
                buy_plan: '' // 购买计划
            },
            successHint: '提交成功', // 提交表单成功的文本提示
            // helpResult: [],
            product_type: '', // 索要价格的产品类型
            privacyform: {}, // 隐私条款内容
            formSubmit: {},  // 有没有提交过表单
            getCodeText: '获取验证码',
            currentTime: 60,
            getCodeState: false,
        }
    },
    created () {
        let defailtFrom = localStorage.getItem('defalFrom')
        if (JSON.parse(defailtFrom)) {
            this.applyForm = true
            this.formItem = JSON.parse(defailtFrom)
            this.formItem.activity_id = this.$route.query.id
            console.log('进入默认缓存',this.formItem);
        }
       console.log('再次进入默认',this.$route.query.id);
       this.getOldFormdata()
       this.getIndustryLabelPort()
        
    },
    activated () {
        // this.applyForm = false
    },
    mounted () {
        window.onpageshow = function (e) {
            if (e.persisted || (window.performance && window.performance.navigation.type === 2)) {
                window.location.reload()
            }
        }
        this.getPricacyList()
    },
    deactivated () {
        console.log('离开',this.formItem);
        
    },
    props: {
        caseDetails: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    methods: {
        // 获取类型数据
      getIndustryLabelPort () {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0
        })
        getIndustryLabel().then(res => {
            if (res.errCode === 0) {
                var data = res.data
                this.labelList = data
                this.$toast.clear()
                } else {
                this.$toast.clear()
                this.$toast(res.errMsg)
                }
            })
        },
        // 获取验证码
        getCode () {
            if(!/^1[23456789]\d{9}$/.test(this.formItem.mobile)) {
                this.$toast('请填写正确的手机号')
                return false
            }
            let para = {
                mobile: this.formItem.mobile
            }
            getPhoneCode(para).then(res => {
                console.log('获取的验证码',res);
                if (res.errCode != 0) {
                    this.$toast(res.errMsg)
                }
            })
            this.getCodeText= "60秒"
            this.getCodeState = true
            setTimeout(this.getcodeNumber,1000)
        },
        getcodeNumber(){
            let numTime = this.currentTime;
            numTime--;
            this.getCodeText= numTime+"秒"
            this.currentTime = numTime
    
            if (numTime <= 0){
                this.getCodeText= "获取验证码"
                this.getCodeState = false
                this.currentTime= '60'
            }else{
                setTimeout(this.getcodeNumber,1000)
            }
        },
        // 获取填写过的表单数据(进行默认填充)
        getOldFormdata () {
            getOldActivity().then(res => {
                // console.log('默认表单显示之前',res);
                if (res.data) {
                   this.formSubmit =  res.data
                   this.defForm = res.data
                }
                // console.log('查看下1111111',this.formSubmit);
            })
        },
        // 获取隐私条款
        getPricacyList () {
            getPricacy().then(res => {
                this.privacyform = res.data
            })
        },
        // 跳转隐私
        gotoprivacy () {
            console.log('去隐私页面',this.formItem);
            let newFrom = JSON.stringify(this.formItem)
            localStorage.setItem('defalFrom',newFrom)
            this.$router.push({
                name: 'pricacy',
            })
        },
        // 打开填写表单
        showApplyForm () {
            console.log('---',this.defForm);
            // this.applyForm = true
            if (!this.formSubmit.form_submited || this.formSubmit.form_id != 0) {
                this.applyForm = true
            } else {
                
                // this.defForm.activity_id = this.$route.query.id
                let params = Object.assign({}, this.defForm)
                params.activity_id = this.$route.query.id
                params['is_first'] = 0 // 0 不是第一次提交，不进行验证 验证码正确性
                console.log('直接进行提交参数',params);
                this.commotFormPort(params)
            }
            
        },

        // 初始化表单数据
        initForm () {
            var formItem = { ...this.formItem }
            for (var i in formItem) {
                formItem[i] = ''
            }
            this.formItem = formItem
            this.product_type = ''
        },

        closeEvent () {
            this.applyForm = false
            this.commitSuccess = false
        },

        blurChange () {
            setTimeout(() => {
                const scrollHeight =
                    document.documentElement.scrollTop ||
                    document.body.scrollTop ||
                    0
                window.scrollTo(0, Math.max(scrollHeight - 1, 0))
            }, 100)
        },
        blurIndustry () {
            this.industryShow = true
        },
        blurCity() {
            this.cityShow = true
        },
        handleCitySure(data) {
            this.cityShow = false
            this.formItem.city = data[0].name+','+data[1].name
        },
        onCancel(picker, value, index) {
            // console.log('查看下',picker,value.id,index);
            this.industryShow = false
        },
        onConfirm (value,index) {
            console.log('查看下',value,index);
            console.log('数据', this.labelList);
            this.industryShow = false
            let namearr = []
            value.selectedOptions.forEach(ele => {
                namearr.push(ele.name)
            })
            this.industry_parent_id = value.selectedOptions[0].id
            this.industry_id = value.selectedOptions[1].id
            this.industryName = namearr.join(',')
        },
        handleData(list, num) {
            let inde1 = num[0]
            let inde2 = num[1]
            let industry_id = ''
            let second = list.filter((element,ind) => {
                if (ind == inde1) {
                     this.industry_parent_id = element.id
                     return element
                }
            });
            second[0].children.forEach((val,inde) => {
                if (inde == inde2) {
                     
                     return this.industry_id = val.id
                }
            })
           console.log('父级id',this.industry_parent_id,'子级',second, '子级id',this.industry_id);
        },
        // 单击提交表单
        commitApplyForm () {
            console.log('提交的',this.formItem);
            if (!this.formItem.name) {
                this.$toast('请输入您的姓名')
            } else if (!this.formItem.mobile) {
                this.$toast('请输入您的手机号')
            } else if (!/^1[23456789]\d{9}$/.test(this.formItem.mobile)) {
                this.$toast('请填写正确的手机号')
            }else if (!this.formItem.code) {
                this.$toast('请填写验证码')
            } else if (!this.formItem.email) {
                this.$toast('请输入您的Email')
            } else if (this.formItem.email.indexOf('@') === -1) {
                this.$toast('请填写正确的Email')
            }else if (!this.formItem.city) {
                this.$toast('请选择您的城市')
            } else if (!this.formItem.company) {
                this.$toast('请输入您的公司名')
            } else if (!this.formItem.identity) {
                this.$toast('请选择您的身份')
            } else if (!this.formItem.like_product.length) {
                this.$toast('请选择您感兴趣的产品')
            } else if (!this.formItem.buy_plan) {
                this.$toast('请选择您的购买计划')
            } else if (this.formItem.privacyData.length < 1 && this.privacyform.status == 1) {
                this.$toast('请您勾选隐私条款')
            }
             else {
                var params = {
                    user_id: this.$store.state.user.id , // || 51
                    // user_id: this.$store.state.user.id,
                    activity_id: this.activity_id,
                    industry_parent_id: this.industry_parent_id,
                    industry_id: this.industry_id
                }
                Object.assign(params, { ...this.formItem })
                params.like_product = params.like_product.join()
                console.log('打印参数', params)
                params.type = 1 // 活动填写表单
                this.commotFormPort(params)
            }
        },
        /** 网络请求 **/
        // 表单提交
        commotFormPort: throttle(function (params) {
            console.log('打印参数', params)
            activityCreateForm(params)
                .then((res) => {
                    if (res.errCode === 0) {
                        if (
                            this.caseDetails.redirect_url &&
                            this.caseDetails.is_form
                        ) {
                            this.$toast({
                                message: '提交成功',
                                duration: 1000
                            })
                            const timer = setTimeout(() => {
                                clearTimeout(timer)
                                window.location.href = this.caseDetails.redirect_url
                            }, 600)
                        } else {
                            this.commitSuccess = true
                            if (this.formItem.is_sign === '1') {
                                this.successHint = '签到成功'
                            } else {
                                this.successHint = '提交成功'
                            }
                            this.initForm()
                            this.$parent.getExampleDetailPort()
                        }
                    } else {
                        this.$toast(res.errMsg)
                    }
                })
                .catch((err) => {
                    console.log('表单提交失败', err)
                    this.$toast('表单提交失败,请稍后重试')
                })
        }, 3000)
    }
}
</script>

<style lang="scss" scoped>

.apply-form-container {
    
    .van-popup {
        border-radius: 6px;
    }
    .privacy-foo {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
    }
    .form-container {
        width: rem(303);
        /*height: rem(520);*/
        background: #fff;
        padding: rem(20) 0;
        .form-content {
            width: 85%;
            height: 100%;
            margin: 0 auto;
            .btn-switch {
                display: flex;
                justify-content: center;
                color: #2c2c2c;
                font-size: 15px;
                font-weight: bold;
                margin-bottom: rem(18);
                .btn {
                    background: #f5f5f5;
                    width: rem(115);
                    height: rem(30);
                    border: none;
                    outline: none;
                    border-radius: 4px;
                    &:nth-child(even) {
                        margin-left: 20px;
                    }
                }
                .select-btn {
                    background: $base-color;
                    color: #fff;
                    transition: all 0.2s;
                }
            }
            .form-list {
                height: rem(310);
                overflow-x: hidden;
                overflow-y: auto;
                .item {
                    margin: rem(6) 0;
                    .hint-title {
                        color: #2c2c2c;
                        font-size: rem(12);
                        display: inline-block;
                        margin-bottom: 5px;
                        .sign {
                            color: #d01818;
                            margin-right: 5px;
                        }
                    }
                    .content {
                        display: flex;
                        align-items: center;
                        width: 98%;
                        height: rem(30);
                        background: #f5f5f5;
                        border-radius: 4px;
                        margin-bottom: rem(5);
                        .left-icon {
                            width: 15%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: relative;
                            .iconfont {
                                color: #4d4d4d;
                                font-size: rem(18);
                            }
                            .icon-xingming {
                                font-size: rem(15);
                            }
                            &:after {
                                content: '';
                                width: 1px;
                                height: rem(18);
                                background: #afafaf;
                                position: absolute;
                                top: 50%;
                                right: 0;
                                margin-top: rem(-9);
                            }
                        }
                        .right-input {
                            width: 85%;
                            padding-left: rem(10);
                            input {
                                width: 100%;
                                height: rem(30);
                                border: none;
                                background: none;
                            }
                        }
                        .code_input {
                            display: flex;
                            align-items: center
                        }
                    }
                    .radio-container {
                        height: rem(30);
                        display: flex;
                        align-items: center;
                        font-size: rem(12);
                    }
                    .checkbox-container {
                        font-size: rem(12);
                        &:after {
                            content: '';
                            display: block;
                            clear: both;
                        }
                        .checkbox-option {
                            float: left;
                            width: 50%;
                            margin-bottom: 6px;
                        }
                        // .checkbox-option:nth-child(9) {
                        //     width: 100%;
                        // }
                        // .checkbox-option:nth-child(10) {
                        //     width: 100%;
                        // }
                    }
                    .group {
                        .van-checkbox {
                            margin: rem(6) 0;
                        }
                        .input-containers {
                            padding-left: rem(24);
                            .input-container {
                                border: 1px solid #cfcfcf;
                                box-sizing: border-box;
                                border-radius: 3px;
                                width: 95%;
                                .product-input {
                                    width: 90%;
                                    height: rem(23);
                                    text-indent: 5px;
                                    border: none;
                                    outline: none;
                                    background: #fff;
                                }
                            }
                        }
                    }
                }
            }
            .hint-text {
                color: #9d9d9d;
                font-size: 12px;
            }
            .commit-btn {
                width: rem(170);
                height: rem(40);
                background: $base-color;
                color: #fff;
                font-size: rem(16);
                border-radius: 4px;
                outline: none;
                border: none;
                display: block;
                margin: 0 auto;
                margin-top: rem(20);
                &:active {
                    background: #51c0dc;
                }
            }
        }
    }
    .success-container {
        width: rem(303);
        /*height: rem(250);*/
        height: auto;
        background: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: rem(45) rem(30);
        box-sizing: border-box;
        .success-img {
            width: rem(84);
            height: rem(84);
        }
        .h3-tit {
            font-size: rem(16);
            color: #2c2c2c;
            margin: rem(10) 0;
        }
        .official-img {
            width: rem(100);
            height: rem(100);
            margin-top: rem(20);
        }
        .hint-text {
            color: #484848;
            font-size: 12px;
        }
        .close-icon {
            position: absolute;
            top: rem(15);
            right: rem(15);
            width: rem(20);
            height: rem(20);
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                font-weight: bold;
                font-size: rem(25);
                color: #9d9d9d;
            }
        }
    }
    .pop-indus {
        /deep/.van-picker{
            width: rem(303);
        }
    }
}
</style>
